"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyTimeObject = exports.modifyString24hr = exports.modifyString12hr = void 0;
var blankValues_1 = require("../../common/blankValues");
var convert_1 = require("../convert/convert");
var get_1 = require("../get/get");
var is_1 = require("../is/is");
var staticValues_1 = require("../staticValues");
exports.modifyString12hr = function (string12hr) {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    var modeToggle = function (preferredModeWhenNull) { return ({
        isolated: function () {
            return exports.modifyString12hr(string12hr).toggleMode(preferredModeWhenNull, false);
        },
        integrated: function () {
            return exports.modifyString12hr(string12hr).toggleMode(preferredModeWhenNull, true);
        },
    }); };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    var cursorSegmentModifier = function (action) { return function ($input) {
        var segment = get_1.getCursorSegment($input);
        return exports.modifyString12hr(string12hr)[action][segment];
    }; };
    var modify = function (modification, skipValidation) {
        var timeObject = convert_1.convertString12hr(string12hr).toTimeObject();
        var modified = modification(timeObject);
        return convert_1.convertTimeObject(modified, skipValidation).to12hr();
    };
    return {
        increment: {
            hrs12: {
                isolated: function () {
                    return modify(function (timeObject) { return exports.modifyTimeObject(timeObject).increment.hrs12.isolated(); });
                },
                integrated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).increment.hrs12.integrated();
                    });
                },
            },
            minutes: {
                isolated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).increment.minutes.isolated();
                    });
                },
                integrated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).increment.minutes.integrated();
                    });
                },
            },
            mode: modeToggle('AM'),
            cursorSegment: cursorSegmentModifier('increment'),
        },
        decrement: {
            hrs12: {
                isolated: function () {
                    return modify(function (timeObject) { return exports.modifyTimeObject(timeObject).decrement.hrs12.isolated(); });
                },
                integrated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).decrement.hrs12.integrated();
                    });
                },
            },
            minutes: {
                isolated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).decrement.minutes.isolated();
                    });
                },
                integrated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).decrement.minutes.integrated();
                    });
                },
            },
            mode: modeToggle('PM'),
            cursorSegment: cursorSegmentModifier('decrement'),
        },
        toggleMode: function (preferredModeWhenNull, isIntegrated) {
            return modify(function (timeObject) {
                return exports.modifyTimeObject(timeObject).toggleMode(preferredModeWhenNull, isIntegrated);
            }, true);
        },
        clear: {
            hrs12: function () {
                return modify(function (timeObject) { return exports.modifyTimeObject(timeObject).clear.hrs12(); });
            },
            minutes: function () {
                return modify(function (timeObject) { return exports.modifyTimeObject(timeObject).clear.minutes(); });
            },
            mode: function () {
                return modify(function (timeObject) { return exports.modifyTimeObject(timeObject).clear.mode(); });
            },
            all: function () { return modify(function (timeObject) { return exports.modifyTimeObject(timeObject).clear.all(); }); },
        },
    };
};
exports.modifyString24hr = function (string24hr) {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    var modeToggle = function (preferredModeWhenNull) { return ({
        isolated: function () {
            return exports.modifyString24hr(string24hr).toggleMode(preferredModeWhenNull, false);
        },
        integrated: function () {
            return exports.modifyString24hr(string24hr).toggleMode(preferredModeWhenNull, true);
        },
    }); };
    var modify = function (modification, skipValidation) {
        var timeObject = convert_1.convertString24hr(string24hr).toTimeObject();
        var modified = modification(timeObject);
        return convert_1.convertTimeObject(modified, skipValidation).to24hr();
    };
    return {
        increment: {
            hrs24: {
                isolated: function () {
                    return modify(function (timeObject) { return exports.modifyTimeObject(timeObject).increment.hrs24.isolated(); });
                },
                integrated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).increment.hrs24.integrated();
                    });
                },
            },
            minutes: {
                isolated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).increment.minutes.isolated();
                    });
                },
                integrated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).increment.minutes.integrated();
                    });
                },
            },
            mode: modeToggle('AM'),
        },
        decrement: {
            hrs24: {
                isolated: function () {
                    return modify(function (timeObject) { return exports.modifyTimeObject(timeObject).decrement.hrs24.isolated(); });
                },
                integrated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).decrement.hrs24.integrated();
                    });
                },
            },
            minutes: {
                isolated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).decrement.minutes.isolated();
                    });
                },
                integrated: function () {
                    return modify(function (timeObject) {
                        return exports.modifyTimeObject(timeObject).decrement.minutes.integrated();
                    });
                },
            },
            mode: modeToggle('PM'),
        },
        toggleMode: function (preferredModeWhenNull, isIntegrated) {
            return modify(function (timeObject) {
                return exports.modifyTimeObject(timeObject).toggleMode(preferredModeWhenNull, isIntegrated);
            }, true);
        },
    };
};
exports.modifyTimeObject = function (timeObject) {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    var modeToggle = function (preferredModeWhenNull) { return ({
        isolated: function () {
            return exports.modifyTimeObject(timeObject).toggleMode(preferredModeWhenNull, false);
        },
        integrated: function () {
            return exports.modifyTimeObject(timeObject).toggleMode(preferredModeWhenNull, true);
        },
    }); };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    var cursorSegmentModifier = function (action) { return function ($input) {
        var segment = get_1.getCursorSegment($input);
        return exports.modifyTimeObject(timeObject)[action][segment];
    }; };
    return {
        increment: {
            hrs12: {
                isolated: function () { return nudgeIsolatedTimeObjectHrs('up', timeObject); },
                integrated: function () { return nudgeIntegratedTimeObjectHrs('up', timeObject); },
            },
            // hrs24 is just an alias for hrs12 since the 24hr doesn't matter
            hrs24: {
                isolated: function () { return exports.modifyTimeObject(timeObject).increment.hrs12.isolated(); },
                integrated: function () {
                    return exports.modifyTimeObject(timeObject).increment.hrs12.integrated();
                },
            },
            minutes: {
                isolated: function () {
                    var minutes = timeObject.minutes;
                    var newMin = minutes === staticValues_1.maxAndMins.minutes.max
                        ? staticValues_1.maxAndMins.minutes.min
                        : nudgeMinutes(minutes, 'up');
                    return __assign(__assign({}, timeObject), { minutes: newMin });
                },
                integrated: function () {
                    var minutes = timeObject.minutes;
                    if (minutes === staticValues_1.maxAndMins.minutes.max) {
                        return nudgeIntegratedTimeObjectHrs('up', __assign(__assign({}, timeObject), { minutes: staticValues_1.maxAndMins.minutes.min }));
                    }
                    return __assign(__assign({}, timeObject), { minutes: nudgeMinutes(minutes, 'up') });
                },
            },
            mode: modeToggle('AM'),
            cursorSegment: cursorSegmentModifier('increment'),
        },
        decrement: {
            hrs12: {
                isolated: function () { return nudgeIsolatedTimeObjectHrs('down', timeObject); },
                integrated: function () { return nudgeIntegratedTimeObjectHrs('down', timeObject); },
            },
            // hrs24 is just an alias for hrs12 since the 24hr doesn't matter
            hrs24: {
                isolated: function () { return exports.modifyTimeObject(timeObject).decrement.hrs12.isolated(); },
                integrated: function () {
                    return exports.modifyTimeObject(timeObject).decrement.hrs12.integrated();
                },
            },
            minutes: {
                isolated: function () {
                    var minutes = timeObject.minutes;
                    var newMin = minutes === staticValues_1.maxAndMins.minutes.min
                        ? staticValues_1.maxAndMins.minutes.max
                        : nudgeMinutes(minutes, 'down');
                    return __assign(__assign({}, timeObject), { minutes: newMin });
                },
                integrated: function () {
                    var minutes = timeObject.minutes;
                    if (minutes === staticValues_1.maxAndMins.minutes.min) {
                        return nudgeIntegratedTimeObjectHrs('down', __assign(__assign({}, timeObject), { minutes: staticValues_1.maxAndMins.minutes.max }));
                    }
                    return __assign(__assign({}, timeObject), { minutes: nudgeMinutes(minutes, 'down') });
                },
            },
            mode: modeToggle('PM'),
            cursorSegment: cursorSegmentModifier('decrement'),
        },
        toggleMode: function (preferredModeWhenNull, isIntegrated) {
            var hrs12 = timeObject.hrs12, hrs24 = timeObject.hrs24, mode = timeObject.mode;
            var returnVal = __assign({}, timeObject);
            var isAM = is_1.isAmTimeObject(timeObject);
            var get24HrHours = function (targetMode) {
                var hrs24Calculation;
                if (hrs12 === null) {
                    hrs24Calculation = null;
                }
                else {
                    var is12 = hrs12 === 12;
                    var hours24hr = {
                        am: is12 ? 0 : hrs12,
                        pm: is12 ? 12 : hrs12 + 12,
                    };
                    hrs24Calculation = (targetMode === 'AM' ? hours24hr.am : hours24hr.pm);
                }
                return hrs24Calculation;
            };
            if (mode === null) {
                if (isIntegrated && hrs24 !== null) {
                    returnVal.mode = hrs24 > 11 ? 'PM' : 'AM';
                    returnVal.hrs24 = hrs24;
                }
                else {
                    returnVal.mode = preferredModeWhenNull;
                    returnVal.hrs24 = get24HrHours(preferredModeWhenNull);
                }
            }
            else {
                returnVal.mode = isAM ? 'PM' : 'AM';
                returnVal.hrs24 = get24HrHours(isAM ? 'PM' : 'AM');
            }
            if (hrs12 === null && mode === null) {
                return returnVal;
            }
            return straightenTimeObject('hrs24', returnVal);
        },
        clear: {
            hrs24: function () { return (__assign(__assign({}, timeObject), { hrs12: null, hrs24: null })); },
            hrs12: function () { return (__assign(__assign({}, timeObject), { hrs12: null, hrs24: null })); },
            minutes: function () { return (__assign(__assign({}, timeObject), { minutes: null })); },
            mode: function () { return (__assign(__assign({}, timeObject), { mode: null, hrs24: null })); },
            all: function () { return blankValues_1.blankValues.timeObject; },
        },
    };
};
var nudgeMinutes = function (minutes, direction) {
    var modifier = direction === 'up' ? 1 : -1;
    var newMinutes = direction === 'up' ? 0 : 59;
    return (minutes === null ? newMinutes : minutes + modifier);
};
var nudgeIsolatedTimeObjectHrs = function (direction, timeObject) {
    return nudgeTimeObjectHrs({
        direction: direction,
        timeObject: timeObject,
        integration: 'isolated',
        blankCallback: function (copiedObject) {
            if (direction === 'up') {
                if (copiedObject.mode === 'PM') {
                    copiedObject.hrs24 = 13;
                    copiedObject.hrs12 = 1;
                }
                else if (copiedObject.mode === 'AM') {
                    copiedObject.hrs24 = 1;
                    copiedObject.hrs12 = 1;
                }
                else {
                    copiedObject.hrs12 = 1;
                }
            }
            else {
                if (copiedObject.mode === 'PM') {
                    copiedObject.hrs24 = 12;
                    copiedObject.hrs12 = 12;
                }
                else if (copiedObject.mode === 'AM') {
                    copiedObject.hrs24 = 0;
                    copiedObject.hrs12 = 12;
                }
                else {
                    copiedObject.hrs12 = 12;
                }
            }
            return copiedObject;
        },
    });
};
var nudgeIntegratedTimeObjectHrs = function (direction, timeObject) {
    return nudgeTimeObjectHrs({
        direction: direction,
        timeObject: timeObject,
        integration: 'integrated',
        blankCallback: function (copiedObject) {
            // If hours is blank, then it is better to increment in isolation
            return nudgeIsolatedTimeObjectHrs(direction, copiedObject);
        },
    });
};
var nudgeTimeObjectHrs = function (_a) {
    var direction = _a.direction, timeObject = _a.timeObject, integration = _a.integration, blankCallback = _a.blankCallback;
    var hrsType = (integration === 'integrated' ? 'hrs24' : 'hrs12');
    var hrs = timeObject[hrsType];
    var copiedObject = __assign({}, timeObject);
    var isUp = direction === 'up';
    var limit = isUp ? staticValues_1.maxAndMins[hrsType].max : staticValues_1.maxAndMins[hrsType].min;
    var opposingLimit = isUp ? staticValues_1.maxAndMins[hrsType].min : staticValues_1.maxAndMins[hrsType].max;
    var modifier = isUp ? 1 : -1;
    if (typeof hrs === 'number') {
        if (hrs === limit) {
            copiedObject[hrsType] = opposingLimit;
        }
        else {
            copiedObject[hrsType] = (hrs + modifier);
        }
        return straightenTimeObject(hrsType, copiedObject);
    }
    else {
        return blankCallback(straightenTimeObject(hrsType, copiedObject));
    }
};
var straightenTimeObject = function (basedOn, invalidTimeObj) {
    var hrs24 = invalidTimeObj.hrs24, hrs12 = invalidTimeObj.hrs12, minutes = invalidTimeObj.minutes;
    var mode = straightenTimeObjectMode(basedOn, invalidTimeObj);
    var isAM = mode === 'AM';
    var use12hr = basedOn === 'hrs12';
    var get12hrBasedOn24hr = function () {
        var hr12 = (hrs24 !== null && hrs24 > 12 ? hrs24 - 12 : hrs24);
        if (hr12 === 0) {
            return 12;
        }
        return hr12;
    };
    var get24hrBasedOn12hr = function () {
        var hr24 = mode === null
            ? null
            : (!isAM && hrs12 !== null && hrs12 !== 12 ? hrs12 + 12 : hrs12);
        if (hr24 === null) {
            return null;
        }
        if (hr24 === 24) {
            return 0;
        }
        if (hr24 >= 12 && isAM) {
            return (hr24 - 12);
        }
        return hr24;
    };
    var newTimeObject = {
        hrs12: use12hr ? hrs12 : get12hrBasedOn24hr(),
        hrs24: use12hr ? get24hrBasedOn12hr() : hrs24,
        minutes: minutes,
        mode: mode,
    };
    return newTimeObject;
};
var straightenTimeObjectMode = function (basedOn, invalidTimeObj) {
    var hrs24 = invalidTimeObj.hrs24, mode = invalidTimeObj.mode;
    if (mode === null) {
        return null;
    }
    if (basedOn === 'hrs12') {
        return mode === null ? 'AM' : mode;
    }
    if (basedOn === 'hrs24' && invalidTimeObj.hrs24 === null && mode !== null) {
        return mode;
    }
    return hrs24 && hrs24 > 11 ? 'PM' : 'AM';
};
